import React, { useState } from 'react';

const ReverseEngineeringChallenge = ({ challenge }) => {
  const [userSolution, setUserSolution] = useState(''); // To track user input
  const [isCorrect, setIsCorrect] = useState(false); // To track correctness
  const [hasSubmitted, setHasSubmitted] = useState(false); // To track form submission

  const handleSubmit = (e) => {
    e.preventDefault();
    setHasSubmitted(true); // Mark as submitted

    // Check if the solution is correct
    if (userSolution === challenge.solution) {
      setIsCorrect(true);
    } else {
      setIsCorrect(false);
    }
  };

  return (
    <div>
      <p className="text-textWhite mb-4">{challenge.description}</p>

      <div className="bg-gray-800 text-green-400 p-4 rounded-lg">
        <p>Download the binary file and reverse engineer it to find the correct password.</p>
        <a
          href={challenge.binary_file}
          className="text-cyberBlue hover:underline"
          download
        >
          Download Binary
        </a>
      </div>

      <p className="mt-4 text-gray-400">Hint: {challenge.hint}</p>

      <form onSubmit={handleSubmit} className="mt-4">
        <input
          type="text"
          value={userSolution}
          onChange={(e) => setUserSolution(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded-lg"
          placeholder="Enter the password"
        />
        <button type="submit" className="bg-cyberBlue text-black p-2 rounded-lg ml-2">
          Submit
        </button>
      </form>

      {/* Show feedback only after the form has been submitted */}
      {hasSubmitted && (
        isCorrect ? (
          <p className="text-green-500 mt-2">Correct! You've found the password.</p>
        ) : (
          <p className="text-red-500 mt-2">Incorrect. Try again.</p>
        )
      )}
    </div>
  );
};

export default ReverseEngineeringChallenge;
